import Header from '../components/header';
import Footer from '../components/footer'
import React from 'react';
import '../index.css';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { FaPalette, FaLink } from 'react-icons/fa';
import { getProjectData } from '../data/projectData';
import aplus from '../assets/images/1.svg'
import placeholder from '../assets/images/image2.png';

function Projects() {
    const projects = getProjectData();

    return (
        <>
            <Header />

            <Container className="projects-container fade-in-up gap-3 p-3">
                <Row className="justify-content-center p-3 mb-3">
                    <Col className="text-start d-flex align-items-center justify-content-start">
                        <FaPalette className='page-img'></FaPalette>
                        <h2 className="heading m-0">CREATIONS</h2>
                    </Col>
                </Row>
                {projects.map((project, index) => (
                    <Row
                        key={index}
                        className="my-card project w-lg-100 project d-flex align-items-center justify-content-center p-3 mb-4"
                    >
                        
                        <Col lg={project.img ? 8 : 12}>
                            <Row>
                                <Col lg={12} className="text-start">
                                    <h3 className="heading3">
                                        {project.title}
                                        {project.link && (
                                            <a
                                                href={project.link}
                                                className="mx-2"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FaLink />
                                            </a>
                                        )}
                                        {project.notes && project.notes === "GP" && (<Image src={aplus}
                                            alt="grade"
                                            className="grade" />)}
                                        {project.notes && project.notes === "TB" && (<span>Team Based</span>)}
                                    </h3>
                                </Col>
                                {project.img && (
                                    <Col lg={12} className="text-start d-lg-none">
                                    <div className='img-wrapper'>
                                        <Image
                                            src={project.img || placeholder}
                                            alt={project.title}
                                            className="img w-100"
                                            fluid
                                        />
                                        <div className="img-overlay">
                                            <a href={project.link} target="_blank" rel="noopener noreferrer">{project.title}</a>
                                        </div>
                                    </div>
                                </Col>
                                )}

                                <Col lg={12} className="mt-2">
                                    <h4 className="heading4">Description:</h4>
                                    <p>{project.description}</p>

                                    <h4 className="heading4">Features:</h4>
                                    <ul className="my-2">
                                        {project.keyFeatures.map((feature, idx) => (
                                            <li key={idx}>{feature}</li>
                                        ))}
                                    </ul>

                                    <div className="my-2 w-100 d-flex align-items-center justify-content-center justify-content-lg-start flex-wrap">
                                        {project.techUsed.map((tech, idx) => (
                                            <span key={idx} className="badge me-1">
                                                {tech}
                                            </span>
                                        ))}
                                    </div>

                                </Col>
                            </Row>
                        </Col>
                        {project.img && (
                            <Col lg={4} className="text-end d-none d-lg-block">
                                <div className='img-wrapper'>
                                    <Image
                                        src={project.img || placeholder}
                                        alt={project.title}
                                        className="img"
                                        fluid
                                    />
                                    <div className="img-overlay">
                                        <a href={project.link} target="_blank" rel="noopener noreferrer">{project.title}</a>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                ))}

            </Container>

            <Footer />
        </>
    );
}

export { Projects };
